var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499333 0.0406694C0.366 0.0406694 0.24 0.0926685 0.146 0.187336C-0.0486667 0.382002 -0.0486667 0.699335 0.146 0.894668L7.29267 8.04C7.48133 8.22933 7.732 8.33333 7.99867 8.33333C8.266 8.33333 8.51667 8.22933 8.70533 8.04133L15.8527 0.894668C16.0473 0.700001 16.0473 0.382669 15.8527 0.187336C15.758 0.0926685 15.6327 0.0406694 15.4993 0.0406694C15.366 0.0406694 15.24 0.0926685 15.146 0.187336L7.99933 7.33333L0.852667 0.187336C0.758667 0.0926685 0.632667 0.0406694 0.499333 0.0406694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.0881b2f596e5f7117ac8e6599255e774.svg";
export { ForwardRef as ReactComponent };